import { FC } from "react";
import { DialogContent, Typography } from "@mui/material";

export const MissingSubAccountRoleDialogLastStep: FC = () => {
  return (
    <DialogContent>
      <Typography variant="body1" fontWeight="medium" mb={3}>
        Cloudchipr Role has been successfully added
      </Typography>
    </DialogContent>
  );
};
